<template>
    <header>
        <img src="../assets/valentis_logo.svg" alt="Valentis Advisory Logo" class="logo">

        <p id="company_title" v-if="user">{{ user.company }}</p>

        <div class="links">
            <router-link to="/">Dashboard</router-link>
            <router-link to="/settings">Settings</router-link>
            <router-link to="/rules">Rules</router-link>
        </div>

        <div id="filter_tabs" v-if="$route.name === 'Dashboard'">
            <div>Divisions</div>

            <!-- loop each available division: this makes it so that the input doesnt dissapear when you uncheck an input-->
            <label v-for="(div, index) in divisions" v-bind:key="index">
                {{ div }}
                <span class="switch">
                    <!-- bind to vuex selectedDivisions to track selected only -->
                    <input type="checkbox"  v-bind:value="div" v-model="selectedDivisions">
                    <span class="slider"></span>
                </span>
                <!-- <span class="checkmark"></span> -->
            </label>

            <label v-if="undefinedDivIsos">
                Undefined
                <span class="switch">
                    <input type="checkbox"  value="undefined" v-model="selectedDivisions">
                    <span class="slider"></span>
                </span>
                
                <!-- <span class="checkmark"></span> -->
            </label>
        </div>

        <button type="button" class="add-iso" v-on:click="toggleForm" v-if="$route.name === 'Dashboard'">Add New ISO</button>

        <button type="button" class="logout" v-on:click="logoutUser">Logout</button>

    </header>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'AppHeader',
        data() {
            return {
                userOnlyIsos: false, // bool to track if the user has selected to view their isos only
            }
        },
        computed:{
            ...mapGetters([
                'divisions', 
                'user',
                'filters',
            ]),
            selectedDivisions: {
                get() {
                    return this.$store.state.Dashboard.filters.divisions;
                },
                set(value) {
                    this.$store.commit('set_selected_divisions', value);
                }
            },
            undefinedDivIsos: function() {
                for (let i = 0; i < this.$store.state.Dashboard.defaultPosts.length; i++) {
                    for (let x = 0; x < this.$store.state.Dashboard.defaultPosts[i].length; x++) {
                        if (this.$store.state.Dashboard.defaultPosts[i][x].division === '') {
                            return true;
                        }
                    }
                }

                return false;
            }
        },
        watch: {
            selectedDivisions: function() {
                this.filter_isos();
            }
        },
        methods: {
            ...mapActions([
                'logout',
                'toggleSubmitFormVisibility',
                'getProfile',
                'filter_isos'
            ]),
            logoutUser() {
                this.logout();
            },
            toggleForm() {
                this.toggleSubmitFormVisibility();
            },
        },
        created() {
            this.getProfile();
            this.selectedDivisions = this.divisions;
        }
    }
</script>

<style lang="scss" scoped>
    header{
        display: flex;
        flex-direction: column;
        position: fixed;
        left: 0;
        top: 0;
        width: 35rem;
        height: 100vh;
        background-color: $primary-one;
        border-right: 1rem solid $primary-two;
        padding: 4rem 0;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            // background: transparent;
            display: none;;
        }

        // &::-webkit-scrollbar-thumb {
        //     background: #FF0000;
        //     height: 1rem;
        // }

        img{
            width: 100%;
            padding: 0 4rem;
        }

        #company_title{
            font-size: 3rem;
            font-weight: 500;
            line-height: 1.3;
            color: #fff;
            text-align: center;
            padding: 0 2rem;
            margin-bottom: 10rem;
        }

        .links{
            width: 100%;
            border-bottom: 0.1rem solid $primary-two;
            margin-bottom: 10rem;

            a{
                display: block;
                border-top: 0.1rem solid $primary-two;
                padding: 1rem 4rem;
                font-size: 2.2rem;
                font-weight: 300;
                line-height: 1.3;
                color: #fff;
                text-decoration: none;
            }
        }

        #filter_tabs{
            width: 100%;
            border-bottom: 0.1rem solid $primary-two;
            margin-bottom: 10rem;

            div{
                font-size: 1.6rem;
                font-weight: 500;
                line-height: 1.3;
                color: #fff;
                padding: 0 4rem;
                margin-bottom: 1.3rem;
            }

            label {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-top: 0.1rem solid $primary-two;
                position: relative;
                padding: 1rem 4rem;
                font-size: 2.2rem;
                font-weight: 300;
                line-height: 1.3;
                color: #fff;

                input {
                    position: absolute;
                    right: 100rem;

                    &:checked + .slider {
                        background-color: #1ad4dd;
                    }

                    &:checked + .slider:before {
                        -webkit-transform: translateX(2.2rem);
                        -ms-transform: translateX(2.2rem);
                        transform: translateX(2.2rem);
                    }
                }

                .switch {
                    position: relative;
                    display: inline-block;
                    width: 5rem;
                    height: 2.8rem;

                    .slider {
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: #ccc;
                        -webkit-transition: .4s;
                        transition: .4s;
                        border-radius: 34px;

                        &:before {
                            position: absolute;
                            content: '';
                            height: 2rem;
                            width: 2rem;
                            left: .4rem;
                            bottom: .4rem;
                            background-color: white;
                            -webkit-transition: .4s;
                            transition: .4s;
                            border-radius: 50%;
                        }
                    }
                }
            }

            // label{
            //     display: flex;
            //     align-items: center;
            //     justify-content: space-between;
            //     border-top: 0.1rem solid $primary-two;
            //     position: relative;
            //     padding: 1rem 4rem;
            //     font-size: 2.2rem;
            //     font-weight: 300;
            //     line-height: 1.3;
            //     color: #fff;

            //     input{
            //         position: absolute;
            //         right: 200%;
            //     }

            //     input:checked ~ .checkmark{
            //         background-color: #fff;
            //     }

            //     .checkmark{
            //         border: 0.1rem solid $primary-two;
            //         height: 2rem;
            //         width: 2rem;
            //     }
            // }
        }

        button{
            background-color: $primary-two;
            padding: 1.3rem;
            width: 25rem;
            margin: 0 auto;
            border: 0;
            border-radius: 10rem;
            font-size: 1.8rem;
            font-weight: 300;
            line-height: 1.3;
            color: #fff;
            outline: unset;

            &.add-iso {
                margin-bottom: 4px;
            }

            &.logout {
                margin-top: auto;
            }
        }
    }
</style>